# frozen_string_literal: true

module Engine
  module Game
    module G1867
    end
  end
end
